<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item 
          v-for="route in displayRoutes" 
          :key="route.path" 
          :item="route" 
          :base-path="route.path"
          />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    ...mapGetters('dynamicRoute', [
      'currentRoutes'
    ]),
    displayRoutes() {
      // 获取动态路由数据，如果为空则使用空数组
      const dynamicRoutes = this.currentRoutes || []
      let retRouters = []
      
      // 递归处理路由的函数
      const processRouteRecursively = (route) => {
        // 检查路由是否有元数据和标题
        if (!route.meta || !route.meta.title) {
          return null
        }
        
        // 如果没有子路由，直接返回当前路由
        if (!route.children || route.children.length === 0) {
          return route
        }
        
        // 递归处理所有子路由，筛选出可见的子路由
        const visibleChildren = route.children
          .filter(child => child.visible)
          .map(child => processRouteRecursively(child))
          .filter(child => child !== null)
        
        // 根据可见子路由的数量决定返回结果
        if (visibleChildren.length === 0) {
          // 所有子路由都隐藏，返回没有children的路由对象
          return {
            ...route,
            children: undefined
          }
        } else {
          // 多个可见子路由，返回包含处理后子路由的路由对象
          return {
            ...route,
            children: visibleChildren
          }
        }
      }
      
      // 遍历所有动态路由
      dynamicRoutes.forEach(element => {
        if (element.children) {
          // 递归处理每个子路由
          const processedRoutes = element.children
            .map(route => processRouteRecursively(route))
            .filter(route => route !== null)
          
          retRouters = processedRoutes
        }
      })

      console.log('retRouters', retRouters)
      
      // 返回处理后的路由数组
      return retRouters
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .el-menu{
    span{
      color: #000;
    }
    .el-menu-item.is-active {
      // .sub-item{
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      // }
      span{
        color: #1890ff !important;
      }
    }
  }
</style>
